import reporter from './reporter'
import locale from './locale'
export default {
  serverUrl:
    process.env.NODE_ENV === 'production'
      ? 'https://api-sme-prod.zwiz.app/'
      : 'https://d377fqxyetzl3p.cloudfront.net/',
  // serverUrl: 'https://api-sme-prod.zwiz.app/',
  // https://d3k49jhriitw3f.cloudfront.net/zwiz-api/ change for build prod
  serverWebhookUrl: ' https://zwiz-sme-wh.zwiz.app/',
  // serverUrlAws: 'https://api-sme-prod.zwiz.app/zwiz-api/',
  serverUrlAws:
    process.env.NODE_ENV === 'production'
      ? 'https://api-sme-prod.zwiz.app/zwiz-api/'
      : 'https://d377fqxyetzl3p.cloudfront.net/zwiz-api/',
  serverUrlSso:
    process.env.NODE_ENV === 'production'
      ? 'https://api-zwiz-sso-prod.zwiz.app/'
      : 'https://api-zwiz-sso.zwiz.app/',
  socketUrl: 'https://api-sme-socket.zwiz.app',
  // scheduleUrl: 'https://d2asa7hs2cbd06.cloudfront.net/',
  scheduleUrl:
    process.env.NODE_ENV === 'production'
      ? 'https://d2asa7hs2cbd06.cloudfront.net/'
      : 'https://d377fqxyetzl3p.cloudfront.net/',
  facebookUrl: 'https://graph.facebook.com/',
  zrmUrl: process.env.NODE_ENV==="production" ? 'https://api-zrmz.zwiz.app/' : 'https://d2htkkpl20x438.cloudfront.net/',
  zrmDomain: process.env.NODE_ENV==="production" ? 'https://zrmz.app/' : 'https://develop.zrm-app.zwiz.app/',
  zrmLineLiff: process.env.NODE_ENV === 'production' ? 'https://liff.line.me/2002479744-y7YeQxlY' : 'https://liff.line.me/2002479744-9aw4k0yw',
  appid: '489929571406302',
  sentry_dsn: 'https://137135facd7740e1b990f6e8123dee7e@o946970.ingest.sentry.io/5908110',
  maintenance: process.env.MAINTENANCE || false,
  theme: {
    logo: '/static/img/logo_white.png',
    small_logo: '/static/img/logo-small.png',
    small_logo_white: '/static/img/logo-small1.png',
    short_small_logo: '/static/img/logo-small-mobile.png',
    hide_zwiz: false,
    email_contact: 'sales@zwiz.ai',
    header_color: 'white',
    header_background_color: '#504F4F',
    brand_color: '#ED1E79', // #ed1839    Default is #FF706B
    secondary_color: '#ff687f' // #ff687f
  },

  fb_scope:
    'email,pages_show_list,pages_messaging,page_events,pages_read_engagement,pages_manage_metadata,pages_read_user_content,pages_manage_ads,pages_manage_posts,pages_manage_engagement,public_profile,instagram_basic,instagram_manage_messages,instagram_manage_comments,ads_management,ads_read',

  reporter: reporter,
  locale: locale.locale
}



// WEBPACK FOOTER //
// ./src/config/index.js